import { FC } from 'react'

import { TServiceItem } from '@/shared/types/deprecated-types'

import { ServiceItem } from './ui/ServiceItem/ServiceItem'

import cl from './styles.module.scss'

export type ServicesProps = {
	services: TServiceItem[]
}

export const Services: FC<ServicesProps> = ({ services }) => {
	return (
		<section className={cl.section}>
			<div className={cl.header}>
				<h1 className={cl.title}>Услуги</h1>
			</div>
			<div className={cl.content}>
				{services.map(service => (
					<ServiceItem service={service} key={service.LINK_VALUE} />
				))}
			</div>
		</section>
	)
}
